import styled from 'styled-components';
import { BUTTON_VARIANTS } from './Button.constant';

export const Container = styled.button<{
  variant: keyof typeof BUTTON_VARIANTS;
  block: boolean;
}>`
  background-color: ${({ theme, variant }) =>
    variant === BUTTON_VARIANTS.outlined
      ? theme.configs.CTAButton.fontColor
      : theme.configs.CTAButton.bgColor};
  color: ${({ theme, variant }) =>
    variant === BUTTON_VARIANTS.outlined
      ? theme.configs.CTAButton.bgColor
      : theme.configs.CTAButton.fontColor};
  border: 1px solid ${({ theme }) => theme.configs.CTAButton.bgColor};
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  width: ${({ block }) => (block ? '100%' : 'auto')};
  text-transform: uppercase;
`;

export const ButtonLink = styled.button`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
`;
